export const Icons: any = {
    "HOME_DASHBOARD": 'controlpanel', // 首页 - 控制面板
    "CLIENT_TRADE": 'customer_transaction', // 客户 - 客户管理
    "CLIENT_MANAGER": 'customer_management', // 客户 - 客户交易
    "ACCOUNT_MANAGER": 'personal_center', // 账号 - 账号管理
    "REBATE_MANAGER": 'money_management', // 佣金 - 佣金管理
    "REBATE_SETTING": 'rebatesetting', // 佣金 - 返佣设置
    "FUND_MANAGER": 'commission_managemen', // 资金 - 资金管理
    "TRADE_MANAGER": 'transaction_manageme', // 交易 - 交易管理
    "REFERRAL_MANAGER": 'promotion', // 推广- 推广管理
    "DOWNLOAD_MANAGER": 'account_security', // 下载- 下载管理
};
